


























































































































import Vue from 'vue'
import { Action, Getter, namespace } from "vuex-class";
import {Component, Prop} from 'vue-property-decorator'
import ScorecardBadgeHeading from '@/pages/dashboard/components/Scorecard/ScorecardBadgeHeading.vue'
import Loading from '@/components/Loading.vue'
import {timeSince} from '@/utils/time'
import {getTextEllipsis} from '@/domain/NPS'
import {badgeSchemas} from '@/entities/scorecard'
import CommentIcon from '@/assets/img/Icons/linkicons/comment.svg'
import CommentBlueDotIcon from '@/assets/img/Icons/linkicons/comment_bluedot.svg'
import NoticesComposer from '@/components/Notices/NoticesComposer.vue'
import { IRecipient } from '@/entities/notices'

const AuthModule = namespace('auth')

@Component<DashboardResponsesList>({
    components: {ScorecardBadgeHeading, Loading, NoticesComposer },
    filters: {
        timeSince
    }
})
export default class DashboardResponsesList extends Vue {
    @Prop(String)
    public displayKey !: string

    @Prop({default: () => []})
    public displayResponses?: object[]

    @Prop({type: String, default: 'nps'})
    public type ?: string

    @Prop({type: String, default: ''})
    public freeText !: string

    @Prop({type: Boolean, default: true})
    public isFiveScore!: boolean

    @Prop({type: Boolean, default: true})
    public loading!: boolean

    @Prop({type: Boolean, default: false})
    public showBadges ?: boolean

    @Prop({type: Boolean, default: false})
    public hasSelectedBadge ?: boolean

    @Prop({type: Boolean, default: false})
    public resultsDepleted ?: boolean

    @Getter public $companyVars

    @AuthModule.Getter public getUser

    @Getter
    recipients!: IRecipient[]

    @Action private loadRecipients
    @Action private setComposerQuestion
    @Action private setComposerNoticeType
    @Action private setComposerRecipients

    private showNoticeComposer = false

    public onClickResponse(id) {
        const query = {...this.$route.query, chat: id}
        this.$router.push({path: this.$route.path, query})
    }

    shouldShowStatusIconForResponse(response) {
        return response.chat_count || response.note_count || response.automation_count || response.response_count > 1
    }

    private get canShowResponseShoutout() {
        // We need to make sure response shoutouts does not show if either Send Notices or Insights V3 are turned off
        return this.getUser?.canSendResponseShoutout
    }

    // color class for cicle
    public getCircleClass(response) {
        let {questionKey} = this.$route.params
        switch (this.type) {
            case 'csat':
                if (questionKey === 'initial_csat_c' || questionKey === 'initial_5star_c') {
                    questionKey = 'answer'
                }
                if (response[questionKey] > 3) {
                    return 'positive'
                } else if (response[questionKey] < 3) {
                    return 'negative'
                } else {
                    return 'neutral'
                }
            case 'nps':
                // fix 5star color
                if (this.isFiveScore) {
                    if (response.answer > 3) {
                        return 'positive'
                    } else if (response.answer < 3) {
                        return 'negative'
                    } else {
                        return 'neutral'
                    }
                }
                if (questionKey && /_nps_c/.test(questionKey)) {
                    if (response[questionKey] >= 9 || questionKey === 'initial_nps_c' && response.answer >= 9) {
                        return 'positive'
                    } else if (response[questionKey] >= 7 || questionKey === 'initial_nps_c' && response.answer >= 7) {
                        return 'neutral'
                    } else {
                        return 'negative'
                    }
                } else {
                    if (response.answer > 8) {
                        return 'positive'
                    } else if (response.answer < 7) {
                        return 'negative'
                    } else {
                        return 'neutral'
                    }
                }
            case 'freetext':
                return this.getSentimentClass(response[this.freeText])
            // case 'multi':
            //     return 'neutral'
            default:
                if (this.isFiveScore) {
                    if (response.answer > 3) {
                        return 'positive'
                    } else if (response.answer < 3) {
                        return 'negative'
                    } else {
                        return 'neutral'
                    }
                }
                if (response.answer > 8) {
                    return 'positive'
                } else if (response.answer < 7) {
                    return 'negative'
                } else {
                    return 'neutral'
                }
        }
    }

    public getCircleText(response) {
        let {questionKey} = this.$route.params
        switch (this.type) {
            case 'csat': {
                if (questionKey === 'initial_csat_c' || questionKey === 'initial_5star_c') {
                    questionKey = 'answer'
                }
                const map = {1: 1, 2: 2, 3: 3, 4: 4, 5: 5}
                return map[response[questionKey]] || ''
            }
            case 'nps': {
                return !questionKey || questionKey === 'all' ||
                questionKey === 'archived' || questionKey === 'initial_nps_c'
                    ? response.answer : response[questionKey]
            }
            // case 'multi':
            //     return String(this.convUiQuestions[questionKey].options[response[questionKey]]
            //         || response[questionKey])[0] || ''
            case 'freetext': {
                const map2 = {'-1': '-N', '0': 'N', '1': 'P'}
                return map2[response[questionKey]] || ''
            }
            default: {
                return response.answer
            }
        }
    }

    public getSentimentClass(category) {
        return {
            positive: Number(category) === 1,
            neutral: Number(category) === 0,
            negative: Number(category) === -1
        }
    }

    public answerChange(response): number {
        if (response.answer >= 0 && response.previous_answer && response.previous_answer >= 0) {
            return response.answer - response.previous_answer;
        }

        return 0;
    }

    public getComment(text) {
        return getTextEllipsis(text, 200)
    }

    public getBadge(badge) {
        return badge.label || badge.badge
    }

    public getBadgeStyle(badge) {
        if (!badge) {
            return ''
        }
        if ((badge as any).type === 'positive' && badgeSchemas[badge.badge]) {
            const {foreColor, backColor} = badgeSchemas[badge.badge]
            return `backgroundColor: ${backColor}; color: ${foreColor}`
        } else {
            return `backgroundColor: #F4F6FC; color: #A9B4CB;`
        }
    }

    public commentIcon(chatOutgoing) {
        return chatOutgoing ? CommentIcon : CommentBlueDotIcon
    }

    private async onClickShoutout(response) {
        this.setComposerQuestion({ id: Number(response.id), comment: response.comment })
        this.setComposerNoticeType('shoutout')

        // We should only load recipients if shoutout is clicked to avoid loading recipients list unnecessarily.
        if (!this.recipients?.length) {
            await this.loadRecipients()
        }
        this.setComposerRecipients(this.responseShoutoutRecipients)

        this.showNoticeComposer = true
    }

    private closeResponseShoutout() {
        this.showNoticeComposer = false
        this.setComposerQuestion(null)
    }

    public get shoutoutNoticeLoading() {
        return this.showNoticeComposer && !this.recipients.length
    }

    // Response shoutouts are set to be broadcasted to everyone by default
    public get responseShoutoutRecipients() {
        return [this.recipients.find(recipient => recipient.field === 'everyone')]
    }
}
